/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { NotAuthorizedPage } from 'src/appShell/NotAuthorizedPage';
import { NotFoundPage } from 'src/appShell/NotFoundPage';
import { routeTable } from 'src/core/utils/routeTable';

export const NotFoundRedirect = () => (
    <Switch>
        <Route exact path={routeTable.notAuthorizedPage()} component={NotAuthorizedPage} />
        <Route exact path={routeTable.notFoundPage()} component={NotFoundPage} />
        <Redirect to={routeTable.notFoundPage()} />
    </Switch>
);
